import React from 'react';

const UpdateFichePage = () => {
  return <div>Page pour mettre à jour une fiche</div>;
};

export default UpdateFichePage;
